<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Daftar Proyek</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/indagproyek">Daftar Proyek</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Daftar Proyek</h4>
                  <p class="card-title-desc mb-0">Daftar Proyek.</p>
                </div>
                <div>
                  <!-- <button type="button" class="btn btn-success" @click="form.show = true">Tambah Baru</button> -->
                </div>
              </div>

              <hr>

              <data-attribut :data="indagproyek">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th class="text-center">No</th>
                        <th>ID Proyek / Nama Perusahaan</th>
                        <th>Urai Proyek</th>
                        <th>Kapasitas</th>
                        <th class="text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in indagproyek.data" :key="index">
                        <td scope="row" class="text-center">{{ indagproyek.from + index }}</td>
                        <td scope="row">
                          <div v-text="row.nama_perusahaan" class="fw-bold"></div>
                          <span v-text="row.id_proyek"></span>
                        </td>
                        <td scope="row" v-text="row.urai_2015"></td>
                        <td scope="row" v-text="`${row.volume} ${row.satuan}`"></td>
                        <td scope="row" class="text-center">
                          <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> |
                          <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                        </td>
                      </tr>
                      <tr v-if="indagproyek.data.length == 0">
                        <td scope="row" colspan="6" class="text-center">
                          <i>Tidak ditemukan data!</i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </data-attribut>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah' : 'Tambah') + ' Proyek'" backdrop="static"
    size="xl">
    <template #default>
      <form @submit.prevent="action">

        <div class="d-flex">
          <div class="p-3 pt-0 flex-fill">
            <div class="mb-2 row">
              <label for="nama_perusahaan" class="col-sm-2 col-form-label">Nama Perusahaan</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="nama_perusahaan"
                  v-model="form.data.nama_perusahaan">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="nama_pemilik" class="col-sm-2 col-form-label">Nama Pemilik</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="nama_pemilik"
                  v-model="form.data.nama_pemilik">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="alamat" class="col-sm-2 col-form-label">Alamat</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="alamat" v-model="form.data.alamat_jalan">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="badan_usaha" class="col-sm-2 col-form-label">Badan Usaha</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="badan_usaha"
                  v-model="form.data.jenis_badan_usaha">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="jenis_industri" class="col-sm-2 col-form-label">Jenis Industri</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="jenis_industri"
                  v-model="form.data.jenis_industri">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="jenis_produk" class="col-sm-2 col-form-label">Jenis Produk</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="jenis_produk"
                  v-model="form.data.jenis_produk">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="kbli" class="col-sm-2 col-form-label">KBLI</label>
              <div class="col-sm-10">
                <input type="text" readonly class="form-control-plaintext" id="kbli" v-model="form.data.kbli_bkpm">
              </div>
            </div>
          </div>

          <!-- <div>
    <button type="button" class="btn btn-outline-success">Ubah Perusahaan</button>
  </div> -->
        </div>

        <ul class="nav nav-tabs mb-3">
          <li class="nav-item"><a class="nav-link cp active">Proyek</a></li>
          <!-- <li class="nav-item"><a class="nav-link cp">Export</a></li> -->
        </ul>

        <div class="row">
          <div class="d-flex">
            <div class="flex-fill mx-3">
              <div class="mb-2 row">
                <label for="id_proyek" class="col-sm-2 col-form-label">ID Proyek</label>
                <div class="col-sm-10">
                  <input type="text" :readonly="form.readonly" class="form-control-plaintext" id="id_proyek"
                    v-model="form.data.id_proyek">
                </div>
              </div>
            </div>
            <div>
              <button type="button" v-if="form.readonly" class="btn btn-outline-success"
                @click="form.readonly = false">Ubah</button>
              <button type="button" v-if="!form.readonly" class="btn btn-primary me-2" @click="action">Simpan</button>
              <button type="button" v-if="!form.readonly" class="btn btn-danger"
                @click="form.readonly = true">Batal</button>
            </div>
          </div>

          <div class="col-md-6">
            <div class="px-4 py-2 shadow-sm border">
              <div class="mb-2 row">
                <label for="urai_2015" class="col-sm-5 col-form-label">Uraian Proyek</label>
                <div class="col-sm-7">
                  <textarea :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="urai_2015" :readonly="form.readonly" rows="2" v-model="form.data.urai_2015"></textarea>
                </div>
              </div>
              <div class="mb-2 row">
                <label for="nama_produk" class="col-sm-5 col-form-label">Nama Produk</label>
                <div class="col-sm-7">
                  <textarea :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="nama_produk" :readonly="form.readonly" rows="2" v-model="form.data.nama_produk"></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="px-4 py-2 shadow-sm border">
              <div class="mb-2 row">
                <label for="no_iui" class="col-sm-5 col-form-label">No. IUI</label>
                <div class="col-sm-7">
                  <input type="number" :readonly="form.readonly"
                    :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                    id="no_iui" v-model="form.data.no_iui">
                </div>
              </div>
              <div class="mb-2 row">
                <label for="kapasitas" class="col-sm-5 col-form-label">Kapasitas</label>
                <div class="col-sm-7 d-flex gap-2">
                  <input type="text" readonly v-if="form.readonly" class="form-control-plaintext" id="kapasitas"
                    :value="`${form.data.volume} ${form.data.satuan}`">
                  <input type="text" v-if="!form.readonly" class="form-control" id="kapasitas"
                    v-model="form.data.volume">
                  <input type="text" v-if="!form.readonly" class="form-control" id="satuan"
                    v-model="form.data.satuan">
                </div>
              </div>
              <div class="mb-2 row">
                <label for="investasi_jumlah" class="col-sm-5 col-form-label">Nilai Investasi</label>
                <div class="col-sm-7">
                  <input type="number" :readonly="form.readonly"
                    :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                    id="investasi_jumlah" v-model="form.data.investasi_jumlah">
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>
    </template>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import DataAttribut from '@/components/DataAttribut'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import axios from 'axios'

export default {
  layout: Layout,
  components: { Modal, DataAttribut },
  props: {
    indagproyek: Object
  },
  data() {
    return {
      form: {
        show: false,
        id: null,
        readonly: true,
        data: {}
      },
    }
  },
  methods: {
    edit({ id }) {
      this.form.id = id;
      this.form.show = true;
      this.form.readonly = true;
      // console.log(this.form.id)
      axios.get('/admin/indagproyek/' + id)
        .then(res => {
          this.form.data = res.data.proyek; //Object.assign(res.data, this.form.data);
        })
    },
    action() {
      if (this.form.id) {
        this.$inertia.put('/admin/indagproyek/' + this.form.id, this.form.data);
      } else {
        this.$inertia.post('/admin/indagproyek', this.form.data);
      }
      this.form.show = false;
      this.form.id = null;
      this.form.data = {};
    },
    remove(row) {
      if(confirm('Konfirmasi Proses Penghapusan?'))
      this.$inertia.delete('/admin/indagproyek/' + row.id);
    }
  },
}
</script>
